import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobalButton, NavigateLinks } from '@/components';
import { Add as AddIcon } from '@mui/icons-material';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { DepartmentsTable } from './components';
import { departmentsPageBreadcrumbs } from './config';

export const Departments = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(() => departmentsPageBreadcrumbs(navigate), []);

  return (
    <section className="w-full h-full flex flex-col gap-6">
      <NavigateLinks actualPage='Departamentos' breadcrumbs={breadcrumbs} />
      <div className="flex justify-end gap-2.5">
        <GlobalButton
          variant={GlobalButtonVariant.primaryButton}
          action={() => navigate('create')}
        >
          <AddIcon />
          Agregar departamento
        </GlobalButton>
      </div>
      <DepartmentsTable />
    </section>
  );
};
